import React, { useContext, useEffect } from 'react';
import { compose } from 'recompose';

import ChatContext from '../../context/ChatContext';
import ChannelList from '../ChannelList';
import SingleChannelView from '../SingleChannelView';
import { withChatContextProviderReady } from '../../context/ChatContext/withChatContextProvider';
import useComponentMounted from '../../hooks/useComponentMounted';

import {
  ChatContainer,
  ChannelContainer,
} from './styles';

const ChatWebView = () => {
  const isComponentMountedRef = useComponentMounted();
  const { setIsChatWebViewOpen } = useContext(ChatContext);

  useEffect(() => {
    if (isComponentMountedRef.current) {
      setIsChatWebViewOpen(true);
    }
    return () => {
      setIsChatWebViewOpen(false);
    };
  }, [setIsChatWebViewOpen, isComponentMountedRef]);

  return (
    <ChatContainer>
      <ChannelList />
      <ChannelContainer>
        <SingleChannelView isWebView />
      </ChannelContainer>
    </ChatContainer>
  );
};

export default compose(
  withChatContextProviderReady,
)(ChatWebView);
